<template>
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info"> 
      </div>
    </div>
    <div class="header-tabs">
        <div class="u-empty">not open</div>
    </div>
    <Contact />
  </div>
</template>

<script>
import Contact from "@components/Contact/Contact";
export default {
  components: { Contact },
  props: {},
  data () {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created () { },
  mounted () { }
}

</script>

<style lang="scss" scoped>
</style>
